import { MetaData } from '../../../models';
import { RouteKeys } from '../../routes/route-keys';

export const metaData: MetaData = {
  title: 'company-details',
  resource: 'admin/company-details',
  source: 'data.data',
};
